import { c as _c } from "react/compiler-runtime";
import { Box, Stack, type ButtonOwnProps, Typography } from '@mui/material';
import type { PropsWithChildren, ReactNode } from 'react';
import { Loader } from '@/components/shared/loader';
import { ButtonWithIcon } from '../buttons/buttonWithIcon';
interface ButtonProps {
  text: string;
  onClick: () => Promise<void> | void;
  disabled?: boolean;
  disabledTooltip?: string;
  variant?: ButtonOwnProps['variant'];
  'data-testid': string;
  icon?: string | ReactNode;
  iconPosition?: 'left' | 'right';
}
export interface PanelFooterProps extends PropsWithChildren {
  primaryButton: ButtonProps;
  secondaryButton?: ButtonProps;
  submitInProgress?: boolean;
  loadingText?: string;
  hideButtons?: boolean;
}
export const PanelFooter = props => {
  const $ = _c(19);
  const {
    primaryButton,
    secondaryButton,
    children,
    submitInProgress,
    loadingText,
    hideButtons
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      gap: "40px",
      justifyContent: "space-between",
      alignItems: "center",
      paddingX: "40px",
      paddingY: "16px",
      boxShadow: "var(--mui-customShadows-panelMd)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flexGrow: 1
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <Box sx={t1}>{children}</Box>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: "12px",
      alignItems: "center"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== loadingText || $[6] !== submitInProgress) {
    t4 = submitInProgress && <><Loader size="medium" /><Typography>{loadingText || "Loading..."}</Typography></>;
    $[5] = loadingText;
    $[6] = submitInProgress;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== hideButtons || $[9] !== primaryButton || $[10] !== secondaryButton || $[11] !== submitInProgress) {
    t5 = !submitInProgress && !hideButtons && <>{secondaryButton && <ButtonWithIcon {...secondaryButton} variant={secondaryButton.variant || "text"} />}<ButtonWithIcon {...primaryButton} variant={primaryButton.variant || "contained"} /></>;
    $[8] = hideButtons;
    $[9] = primaryButton;
    $[10] = secondaryButton;
    $[11] = submitInProgress;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <Stack direction="row" sx={t3}>{t4}{t5}</Stack>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t6) {
    t7 = <Stack direction="row" sx={t0}>{t2}{t6}</Stack>;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};